import { render, staticRenderFns } from "./inline-navigation-item.vue?vue&type=template&id=74b29996"
import script from "./inline-navigation-item.vue?vue&type=script&lang=js"
export * from "./inline-navigation-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports